module.exports = __webpack_public_path__ + "img/avatar-s-12.4ba08df0.jpg";